/**
 * index.js
 *
 * @Author: wangyinan
 * @Date: 2017/7/14 上午11:35
 */
import Menu from './Menu';
import MenuItem from './MenuItem';
import SubMenu from './SubMenu';
import MenuItemGroup from './MenuItemGroup';
import ParallelMenu from './ParallelMenu';

export { MenuItem, SubMenu, MenuItemGroup, ParallelMenu };
export default Menu;



// WEBPACK FOOTER //
// ./src/menu/index.js